import React from 'react';
import { Link } from "react-router-dom";
import Examination_navbar from './Examination_navbar';
import { scrollToTop } from '../Shared/ScrollOnTop';

const OldResults = () => {
    return (
        <>
            <Examination_navbar />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/Dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"><Link to="/ExaminationSystem/ExaminationDashboard">Examination System</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Old Results</li>
                                </ol>
                            </nav>
                            <div className="page-title">Print Old Result Cards</div>
                        </div>
                        <div className="col-md-6">
                            <div className="page-right-actions">
                                <Link to="javascript:;" data-bs-toggle="collapse" data-bs-target="#collapseFilteres"
                                    className="button button-white button-icon">
                                    Filters
                                    <i className="ri-filter-3-line"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OldResults;
